<template>
    <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" :viewBox="getViewBox" :fill="iconFill">
        <slot name="icon" />
    </svg>
</template>
<script>
export default {
    name: "SOIconBase",
    props: {
        iconFill: {
            type: String,
            default: "none",
        },
        viewBox: {
            type: String,
            default: "",
        },
        width: {
            type: [Number, String],
            default: 18,
        },
        height: {
            type: [Number, String],
            default: 18,
        },
    },
    computed: {
        getViewBox() {
            let vBox = this.viewBox;
            if (!vBox) {
                vBox = `0 0 ${this.width} ${this.height}`;
            }

            return vBox;
        },
    },
};
</script>
